import React, {Component} from 'react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import { Form, Input, Modal, Button, Icon } from 'semantic-ui-react'

class Editar extends Component{
	constructor(props){
		super(props)
		this.app= firebase;
		this.database = this.app.firestore().collection(this.props.tabla)
		this.state = {
			id: this.props.data.id,
			nombre: this.props.data.nombre,
			telefono: this.props.data.telefono || '',
			correo: this.props.data.correo || '',
			direccion: this.props.data.direccion || '',
		}
        this.useModal = false;
	}
    changeUsModal=(e)=>{
		this.setState({useModal:e})
	}
    guardarDatos= async ()=>{
		console.log(this.state)
        const newdata = this.database.doc(this.state.id)
        try {
            newdata.update({
                nombre: this.state.nombre,
                telefono: this.state.telefono,
				correo: this.state.correo,
				direccion: this.state.direccion
            })
			alert("Datos Guardados Correctamente")
        } catch (error) {
            this.setState({
                message: 'Ocurrió un error'
            })
            console.log(error)
        }
        this.changeUsModal(false)
    }
    editarProd =(e)=>{
		this.setState({[e.target.name]: e.target.value.toUpperCase()})
	}
	borrar= async (id)=>{
		this.database.doc(id).delete().then(() => {
            console.log("Borrado");
        }).catch((error) => {
            console.error("Error removing document: ", error);
        });
		this.changeUsModal(false)
	}
	render(){
		return (
		<>
			<button className='editar' onClick={() => this.changeUsModal(true)}><Icon name='edit' /></button>
			<Modal 
				onClose={() => this.changeUsModal(false)}
				onOpen={() => this.changeUsModal(true)}
				open={this.state.useModal}>
				<Modal.Header>
					Proveedor: {this.state.nombre} 
					<Button color='red' floated='right' onClick={
						() =>{
							const confirmBox = window.confirm(`Esta accion no se puede revertir!!! Desea borrar ${this.state.clave} ?`)
							if (confirmBox === true) {this.borrar(this.state.id)}
						  }
						}>Borrar Proveedor
					</Button>
				</Modal.Header>
				<Modal.Content>
				<Form>
                    <Form.Field required>
						<label>Nombre:</label> 
						<Input 
							name="nombre"
							type='text'
							value={this.state.nombre}
							onChange={this.editarProd} 
							required
						/>
					</Form.Field>
                    <Form.Field required>
						<label>Telefono:</label> 
						<Input 
							name="telefono"
							type='phone'
							value={this.state.telefono}
							onChange={this.editarProd} 
						/>
					</Form.Field>
					<Form.Field required>
						<label>Correo:</label> 
						<Input 
							name="correo"
							type='email'
							value={this.state.correo}
							onChange={this.editarProd} 
						/>
					</Form.Field>
					<Form.Field required>
						<label>Direccion:</label> 
						<Input 
							name="direccion"
							type='text'
							value={this.state.direccion}
							onChange={this.editarProd} 
						/>
					</Form.Field>
				</Form>
				</Modal.Content>
                <Modal.Actions>
                    <Button onClick={()=>this.guardarDatos()}>Guardar Cambios</Button>
				</Modal.Actions>
			</Modal>
		</>
		)
	}
}

export default Editar;